/*
 * This file was automatically generated. Do not make any changes
 * directly as they may be overwritten.
 *
 * To update this file, run `yarn run generate-api`.
 */
import { apiService } from "assets/scripts/domain/apiService";
/* tslint:disable */
export const GET_URL = "/api/metadata";
export function get() {
    return apiService.post(GET_URL, true, {});
}
/* tslint:enable */ 



// WEBPACK FOOTER //
// ./src/generated/api/metadata.ts